<template>
    <div id="productBoxPage">
        <div class="pcNav" @mouseover="handleMouseover" @mouseleave="handleMouseleave">
            <div class="content-box" >
                <ul class="main-list">
                    <li class="main-list-item" v-for="(typeItem, outerIndex) of prodList" :key="outerIndex">
                        <span class="subType">{{typeItem.typeDesc}}</span>
                        <ul class="sub-list">
                            <ProductItem v-for="(item , index) in typeItem.list" :key="index" :prodInfo="item" class="subProduct" :size="'small'" @productItemClicked="handleClickItem"></ProductItem>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import ProductItem from '../../views/home/components/home-banner/product-item.vue'
export default {

  data () {
    return {
      isShow: false,
      currentType: 0,
      prodList: [
        {
          typeDesc: '直播课堂SaaS/Paas产品',
          id: 1,
          list: [{
            name: '直播云',
            desc: '多场景直播服务平台',
            logoUrl: require('@/assets/pngs/icon_zby.png'),
            type: 2,
            redirectUrl: process.env.VUE_APP_ZBY_WEB,
            redirectType: 'newPage',
            clickType: true
          }
          ]
        },
        {
          typeDesc: '教研教学产品工具',
          list: [{
            name: '魔法好课',
            desc: '多年沉淀的教学资料与方法',
            logoUrl: require('@/assets/pngs/icon_wlhk.png'),
            type: 4,
            redirectUrl: '/production/content',
            redirectType: 'newRouter',
            clickType: true
          },
          {
            name: '教研云',
            desc: '一站式教研服务平台',
            logoUrl: require('@/assets/pngs/icon_jyy.png'),
            type: 3,
            redirectUrl: 'https://www.jiaoyanyun.com',
            redirectType: 'newPage',
            clickType: true
          },
          {
            name: '魔法学习机',
            desc: '让学习更高效',
            logoUrl: require('@/assets/pngs/icon_xuexij.png'),
            type: 4,
            redirectUrl: '/production/learningmachine',
            redirectType: 'newRouter',
            clickType: true
          }
          ]
        },
        {
          typeDesc: '教学解决方案',
          list: [{
            name: '魔法双师课堂',
            desc: '资深教师授课，助力扩科，实现营收',
            logoUrl: require('@/assets/pngs/icon_mfss.png'),
            type: 4,
            redirectUrl: '/production/ssLive',
            redirectType: 'newRouter',
            clickType: true
          },
          {
            name: 'AI英语',
            desc: '用AI技术实现因材施教，提升竞力',
            logoUrl: require('@/assets/pngs/icon_px_ai.png'),
            type: 4,
            redirectUrl: '/production/ai',
            redirectType: 'newRouter',
            clickType: true
          },
          {
            name: '励步英语',
            desc: '线上线下、同班同伴、提供完整的学习解决方案',
            logoUrl: require('@/assets/pngs/icon_libu.png'),
            type: 4,
            redirectUrl: '/production/libu',
            redirectType: 'newRouter',
            clickType: true
          },
          {
            name: '乐加乐',
            desc: '一站式STEAM教育机器人少儿编程机构',
            logoUrl: require('@/assets/pngs/lejiale.png'),
            type: 4,
            redirectUrl: 'https://www.lejiale.com',
            redirectType: 'newPage',
            clickType: true
          }
          ]
        }
      ]
    }
  },
  components: { ProductItem },
  methods: {
    handleClickItem (itemInfo) {
      this.$emit('productItemClicked', itemInfo)
      this.$emit('mouseleave', '')
    },
    handleMouseover (e) {
      this.$emit('mouseover', '')
    },
    handleMouseleave (e) {
      this.$emit('mouseleave', '')
    }
  }
}
</script>
<style lang="scss" scoped>
#productBoxPage{
    .pcNav{
      position: fixed;
      top: 80px;
      left: 0;
      right: 0px;
      transition: background-color 1s;
      height: 400px;
      z-index: 1030;
      color: #fff;
      background-color: #fff;
      box-shadow: 0px 44px 36px 0px rgba(0,0,0,0.2);
      border-top: 1px solid #E8E8E8;
      .content-box{
        width: $main-width;
        padding: 0 87px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        height: 364px;
      }
      .main-list {
        margin-top: 60px;
        padding: 0;
        display: flex;
        .main-list-item {
          margin-right: 30px;
        }
        .sub-list{
          padding: 0;
          margin-top: 25px;
        }
      }
    }
    .subType{
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #A7A7A7;
      border-bottom: 1px solid #E8E8E8;
      line-height: 36px;
      display: flex;
    }
    .subProduct {
      width: 338px;
      height: 72px;
      color: #282828;
      text-align: left;
      margin-bottom: 4px;
      cursor:pointer;
    }
}
</style>
